import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 30 22" fill={color}>
    <g id="Page-1">
      <g id="_x30_02C-Whole-Home-Data-Backup" transform="translate(-208.000000, -1071.000000)">
        <g id="Stacked-Group" transform="translate(205.000000, 892.000000)">
          <g id="Dot" transform="translate(4.000000, 180.000000)">
            <g id="Backup">
              <path
                id="Combined-Shape"
                style={{ fill: 'none', stroke: color }}
                d="M4.6,6.2C5.5,2.6,8.4,0,11.8,0c2.7,0,5,1.6,6.3,4c0.5-0.3,1-0.5,1.5-0.5
						c1.7,0,3.1,1.6,3.1,3.5c0,0,0,0,0,0c0.1,0,0.3,0,0.4,0c2.7,0,4.8,2.4,4.8,5.2s-2.2,5.2-4.8,5.2c-0.1,0-0.3,0-0.4,0v0H5.2
						C2.4,17.5,0,15,0,11.8C0,8.9,2,6.5,4.6,6.2z"
              />
              <circle id="Oval" style={{ fill: '#FFFFFF', stroke: color }} cx="18.4" cy="14.9" r="5.2" />
              <path
                id="Combined-Shape_1_"
                style={{ fill: color }}
                d="M17.7,17.1c0,0,0.1-0.1,0.1-0.1l3.1-3.7c0.2-0.2,0.5-0.2,0.7-0.1c0,0,0,0,0,0
						c0.2,0.2,0.2,0.5,0.1,0.7L18.1,18c0,0-0.1,0.1-0.1,0.1c-0.2,0.1-0.4,0.1-0.6,0l-2.4-1.7c-0.2-0.1-0.2-0.4-0.1-0.6c0,0,0,0,0,0
						c0.2-0.2,0.5-0.2,0.7-0.1L17.7,17.1z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/Backup.js